import { createActions, createReducer } from "reduxsauce";
import { urls } from "../../api/urls";
import { apiConfig } from "../../api/config";
import {
  createSource,
  ISource,
  IUserSource,
  ISourceBackend,
  createUserSource,
  IUserSourceBackend,
} from "../dataMap/source";

/**Actions and types definitions **/
const { Types, Creators } = createActions({
  fetchSourcesRequest: null,
  fetchSourcesSuccess: ["sources"],
  fetchSourcesFailure: ["error"],
  fetchUserSourcesRequest: null,
  fetchUserSourcesSuccess: ["userSources"],
  fetchUserSourcesFailure: ["error"],
  addUserSourceSuccess: ["userSource"],
  removeUserSourceSuccess: ["userSourceId", "sourceId"],
  updateUserSourcesFailure: ["error"],
  toggleUserSource: ["userSourceId"],
  toggleAllUserSource: null,
  toggleAllSourcesRequest: null,
  toggleAllSources: ["userSourceList"],
});

interface ISourceState {
  status: string;
  loading: boolean;
  source: ISource | null;
  error: string;
  sources: ISource[];
  userSources: IUserSource[];
  isAllChecked: boolean;
  isAllUserSourcesChecked: boolean;
}

/** reducer definition */
const INITIAL_STATE: ISourceState = {
  status: "",
  loading: false,
  source: null,
  error: "",
  sources: [],
  userSources: [],
  isAllChecked: false,
  isAllUserSourcesChecked: false,
};

export const request = (state = INITIAL_STATE): ISourceState => {
  return {
    ...state,
    source: null,
    status: "",
    loading: true,
  };
};
export const success = (
  state = INITIAL_STATE,
  action: { sources: ISource[] }
): ISourceState => {
  const isAllChecked = action.sources.some(
    (source) => source.isUserSaved === false
  );
  return {
    ...state,
    loading: false,
    sources: action.sources,
    isAllChecked: !isAllChecked,
    error: "",
  };
};
export const failure = (state = INITIAL_STATE, action: { error: string }) => {
  return {
    ...state,
    loading: false,
    error: action.error,
  };
};
export const requestUser = (state = INITIAL_STATE): ISourceState => {
  return {
    ...state,
    status: "",
    loading: true,
  };
};
export const successUser = (
  state = INITIAL_STATE,
  action: { userSources: IUserSource[] }
): ISourceState => {
  const isAllChecked = action.userSources.length
    ? action.userSources.some((userSource) => userSource.isSelected === false)
    : true;
  return {
    ...state,
    loading: false,
    userSources: action.userSources,
    isAllUserSourcesChecked: !isAllChecked,
    //   action.filterSources.length !== 0 &&
    //   action.filterSources.length === action.sources.length,
    error: "",
  };
};
export const failureUser = (
  state = INITIAL_STATE,
  action: { error: string }
) => {
  return {
    ...state,
    loading: false,
    userSources: [],
    error: action.error,
  };
};
export const addUserSource = (
  state = INITIAL_STATE,
  action: { userSource: IUserSource }
): ISourceState => {
  const newSource = state.sources.find(
    (source) => source.id === action.userSource.source.id
  );
  if (newSource) newSource.isUserSaved = true;
  return {
    ...state,
    status: "",
    isAllUserSourcesChecked: !state.userSources.some(
      (userSource) => userSource.isSelected === false
    ),
    isAllChecked: !state.sources.some((source) => source.isUserSaved === false),
    userSources: state.userSources.concat([action.userSource]),
    sources: [...state.sources],
    loading: false,
  };
};
export const removeUserSource = (
  state = INITIAL_STATE,
  action: { userSourceId: number; sourceId: number }
): ISourceState => {
  const newSource = state.sources.find(
    (source) => source.id === action.sourceId
  );
  if (newSource) newSource.isUserSaved = false;
  const newUserSources = state.userSources.filter(
    (userSource) => userSource.id !== action.userSourceId
  );
  return {
    ...state,
    status: "",
    isAllChecked: false,
    isAllUserSourcesChecked:
      !state.userSources.length ||
      !newUserSources.some((userSource) => userSource.isSelected === false),
    userSources: newUserSources,
    loading: false,
  };
};

export const updateUserSourceFailure = (
  state = INITIAL_STATE,
  action: { error: string }
): ISourceState => {
  return {
    ...state,
    error: action.error,
    loading: false,
  };
};

export const toggleUserSource = (
  state = INITIAL_STATE,
  action: { userSourceId: number }
): ISourceState => {
  const newUserSources = state.userSources.find(
    (source) => source.id === action.userSourceId
  );
  let isAllUserSourcesChecked = state.isAllUserSourcesChecked;
  if (newUserSources) {
    newUserSources.isSelected = !newUserSources.isSelected;
    if (!newUserSources.isSelected) {
      isAllUserSourcesChecked = false;
    } else {
      isAllUserSourcesChecked = !state.userSources.some(
        (source) => source.isSelected === false
      );
    }
  }
  return {
    ...state,
    status: "",
    isAllUserSourcesChecked: isAllUserSourcesChecked,
    userSources: [...state.userSources],
    loading: false,
  };
};

export const toggleAllUserSource = (state = INITIAL_STATE): ISourceState => {
  state.userSources.map(
    (userSource) => (userSource.isSelected = !state.isAllUserSourcesChecked)
  );
  return {
    ...state,
    status: "",
    isAllUserSourcesChecked: !state.isAllUserSourcesChecked,
    userSources: [...state.userSources],
    loading: false,
  };
};

export const toggleAllSources = (
  state = INITIAL_STATE,
  action: { userSourceList: IUserSource[] }
): ISourceState => {
  state.sources.map((source) => (source.isUserSaved = !state.isAllChecked));
  return {
    ...state,
    status: "",
    isAllUserSourcesChecked: !state.isAllChecked,
    isAllChecked: !state.isAllChecked,
    userSources: !state.isAllChecked ? action.userSourceList : [],
    sources: [...state.sources],
    loading: false,
  };
};

export const toggleAllSourcesRequest = (
  state = INITIAL_STATE
): ISourceState => {
  return {
    ...state,
    status: "",
    loading: true,
  };
};

export const HANDLERS = {
  [Types.FETCH_SOURCES_REQUEST]: request,
  [Types.FETCH_SOURCES_SUCCESS]: success,
  [Types.FETCH_SOURCES_FAILURE]: failure,
  [Types.FETCH_USER_SOURCES_REQUEST]: requestUser,
  [Types.FETCH_USER_SOURCES_SUCCESS]: successUser,
  [Types.FETCH_USER_SOURCES_FAILURE]: failureUser,
  [Types.UPDATE_USER_SOURCES_FAILURE]: updateUserSourceFailure,
  [Types.ADD_USER_SOURCE_SUCCESS]: addUserSource,
  [Types.REMOVE_USER_SOURCE_SUCCESS]: removeUserSource,
  [Types.TOGGLE_USER_SOURCE]: toggleUserSource,
  [Types.TOGGLE_ALL_USER_SOURCE]: toggleAllUserSource,
  [Types.TOGGLE_ALL_SOURCES]: toggleAllSources,
  [Types.TOGGLE_ALL_SOURCES_REQUEST]: toggleAllSourcesRequest,
};

export default createReducer(INITIAL_STATE, HANDLERS);

/** action for request  */
export const Actions = {
  ...Creators,
  fetchSources: function (dispatch) {
    dispatch(Creators.fetchSourcesRequest());
    apiConfig
      .get(urls.SOURCES)
      .then((sourcesResponse) => {
        const sources = sourcesResponse.data.map((source: ISourceBackend) => {
          return createSource(source);
        });

        dispatch(Creators.fetchSourcesSuccess(sources));
      })
      .catch(async (error) => {
        dispatch(Creators.fetchSourcesFailure(error.message));
      });
  },
  fetchUserSources: (dispatch) => {
    dispatch(Creators.fetchUserSourcesRequest());
    apiConfig
      .get(urls.USER_SOURCE)
      .then((userSources) => {
        const sources = userSources.data.map(
          (userSource: IUserSourceBackend) => {
            return createUserSource(userSource);
          }
        );

        dispatch(Creators.fetchUserSourcesSuccess(sources));
      })
      .catch((error) => {
        dispatch(Creators.fetchUserSourcesFailure(error.message));
      });
  },
  updateUserSource: (dispatch, source: ISource, userSourceId: number) => {
    // dispatch(Creators.addSourceToFilterRequest());
    if (source.isUserSaved) {
      apiConfig
        .delete(`${urls.USER_SOURCE}${userSourceId}`)
        .then(() => {
          dispatch(Creators.removeUserSourceSuccess(userSourceId, source.id));
        })
        .catch((error) => {
          dispatch(Creators.updateUserSourcesFailure(error.message));
        });
    } else {
      apiConfig
        .post(`${urls.USER_SOURCE}`, {
          sourceid: source.id,
        })
        .then((response) => {
          dispatch(
            Creators.addUserSourceSuccess(createUserSource(response.data))
          );
        })
        .catch((error) => {
          dispatch(Creators.updateUserSourcesFailure(error.message));
        });
    }
  },
  toggleUserSources: (dispatch, userSource: IUserSource) => {
    apiConfig
      .put(`${urls.USER_SOURCE}${userSource.id}/`, {
        ...userSource,
        is_selected: !userSource.isSelected,
      })
      .then(() => {
        dispatch(Creators.toggleUserSource(userSource.id));
      });
  },

  toggleAllSources: (dispatch, isAllSourceSelected: boolean) => {
    dispatch(Creators.toggleAllSourcesRequest());
    if (!isAllSourceSelected) {
      apiConfig.get(`${urls.SOURCE_ALL}`).then((response) => {
        const sources = response.data.map((source) => createUserSource(source));
        dispatch(Creators.toggleAllSources(sources));
      });
    } else {
      apiConfig.delete(`${urls.SOURCE_ALL}`).then(() => {
        dispatch(Creators.toggleAllSources());
      });
    }
  },

  toggleAllUserSources: (dispatch, isAllUserSourceSelected: boolean) => {
    dispatch(Creators.toggleAllSourcesRequest());
    apiConfig
      .get(`${urls.USER_SOURCE_ALL}?selected=${!isAllUserSourceSelected}`)
      .then((response) => {
        dispatch(Creators.toggleAllUserSource());
      })
      .catch((error) => {
        // dispatch(Creators.updateUserSourcesFailure(error.message));
      });
  },
};
